// extracted by mini-css-extract-plugin
module.exports = {"grid":"ImageGrid-module--grid--1s-mB","img":"ImageGrid-module--img--13Qh7"};